import React from "react";
import "../../styles/loader.css";

const DefaultLoader = () => {
  return (
    <div className="loader-container">
      <span className="loader"></span>
    </div>
  );
};

export default DefaultLoader;
